import { withRouter, useLocation } from 'react-router-dom';

import IsvLogo from '../../assets/images/isv.svg';
import Container from '@material-ui/core/Container';
import { ISV_INIT_URL } from '../../commons/constants';


const Banner = withRouter(({ history, hasToReturn, setAccessToReturn}) => {
    const initialForm = '/start-form/';
    const location = useLocation();
    return (
        <Container className="my-4">
            <div className="row d-flex advanced-container">
                <div className="col-lg-10 col-xs-12">
                    <img src={IsvLogo} alt="isv-logo" style={{ height: 37 }} />
                </div>
                {(hasToReturn || hasToReturn === null) && location.pathname !== '/clientes/gs1-b2b-keys/' ?
                <div className="col-lg-2 col-xs-12">
                    <button onClick={() => {
                        if (hasToReturn === null) setAccessToReturn(true);
                        else if (window.location.pathname === initialForm) window.location.href = ISV_INIT_URL;
                        else history.push(initialForm);
                    }} className="isv-btn isv-btn-circle btn-block">
                        Regresar
                    </button>
                </div>
                : ''}
            </div>
        </Container>
    );
});

export default Banner;
